import React from "react";

import CSSModule from "react-css-modules";

import styles from "./ToggleSearchBar.module.scss";

const ToggleSearchBar = ({
    options = [],            // [{ label, value }]
    activeValue,
    onChange,
    onSearch,
    placeholder = "Search..."
}) => {
    return (
        <div styleName="row" className="row justify-content-between align-items-center mb-3 p-1">

            <div styleName="btn-container">
                {options.map((opt) => (
                    <button
                        key={opt.value}
                        styleName={activeValue === opt.value ? "active" : ""}
                        onClick={() => onChange(opt.value)}
                    >
                        {opt.label}
                    </button>
                ))}
            </div>

            {onSearch && (
            <div styleName="search">
                <input
                    type="text"
                    placeholder={placeholder}
                    onChange={(e) => onSearch(e.target.value)}
                />
            </div>
            )}

        </div>
    );
};

export default CSSModule(ToggleSearchBar, styles);